import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=27e4907c&"
import script from "./DialogModal.vue?vue&type=script&lang=js&"
export * from "./DialogModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports